export default __webpack_public_path__ + "static/media/chef_t_happy.6a67563a.svg";